import { PropsWithChildren, useEffect, useMemo, useState } from 'react'
import { TreeView, TreeNode } from './tree-view'

export const OrderItems: React.FC<
    PropsWithChildren & {
        materials: TreeNode
        labors: TreeNode
        onItemsSelected: (values: string[]) => void
        setTableArray: (values: string[]) => void
        selected?: string[]
    }
> = ({ materials, labors, onItemsSelected, setTableArray, selected = [] }) => {
    const childrenNodes = useMemo(() => {
        const nodes = [...(materials?.children || [])]
        if (labors?.children?.length) {
            nodes.push(labors)
        }
        return nodes
    }, [materials, labors])
    const [selectedIds, setSelectedIds] = useState<string[]>([])

    useEffect(() => {
        onItemsSelected(selectedIds)
    }, [selectedIds, onItemsSelected])

    useEffect(() => {
        typeof selected === 'object' &&
            JSON.stringify(selected) !== JSON.stringify(selectedIds) &&
            handleTreeChange(selected)
    }, [selected])

    const handleTreeChange = (selectedValues: string[]) => {
        setSelectedIds(selectedValues)
    }

    return (
        <div className="p-4">
            <TreeView
                data={childrenNodes}
                onChange={handleTreeChange}
                selectedValues={selectedIds} // Pass selected values down
                setTableArray={setTableArray}
            />
        </div>
    )
}
